import { render, staticRenderFns } from "./TapStationSetup.vue?vue&type=template&id=0b364570&scoped=true&"
import script from "./TapStationSetup.vue?vue&type=script&lang=js&"
export * from "./TapStationSetup.vue?vue&type=script&lang=js&"
import style0 from "./TapStationSetup.vue?vue&type=style&index=0&id=0b364570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b364570",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b364570')) {
      api.createRecord('0b364570', component.options)
    } else {
      api.reload('0b364570', component.options)
    }
    module.hot.accept("./TapStationSetup.vue?vue&type=template&id=0b364570&scoped=true&", function () {
      api.rerender('0b364570', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/kiosk/easychope/components/TapStationSetup.vue"
export default component.exports